(function () {

	'use strict';

	angular.module('app')
		.controller('ClientCompanyController', function (
			$scope,
			ClientService,
			$routeParams,
			$timeout,
			$location,
			Location,
			toastr,
			$uibModal,
			Upload,
			ConfirmationModalFactory,
			$filter,
			$q,
			scrollToForm,
			ViewChangeNotificationFactory,
			$rootScope,
			isUniqueService
		) {

			var vm = this;
			vm.params = $routeParams || {};
			vm.company = {
				billingProfile: {
					location: {}
				},
				location: {},
				uniqueSSCCPerPackage: true,
				trackingStatusUpdateEnabled: false,
				createPendingOrderEnabled: false,
				generateMultimodalDangerousGoodsDocument: false
			};

			vm.companyRaw = {};
			vm.companyOld = {};
			vm.goTo = goTo;
			vm.save = save;
			vm.onAccountChange = switchOnAccount;
			vm.onCreditType = switchCreditCard;

			vm.isViewMode = false;
			vm.countries = [];
			vm.postCodes = [];
			vm.searchForZipcode = searchForZipcode;
			vm.searchForCountry = searchForCountry;
			vm.searchForCompanies = searchForCompanies;
			vm.selectCountry = selectCountry;
			vm.selectPostCode = selectPostCode;
			vm.back = back;
			vm.companyId = vm.params.companyId || false;
			vm.changeStatus = changeStatus;
			vm.init = init;
			vm.isUnique = isUnique;
			vm.validateEmail = validateEmail;
			vm.messeage = "";
			vm.statusSwitch = {
				true: $filter('translate')('labels.status.ACTIVE'),
				false: $filter('translate')('labels.status.INACTIVE'),
			};
			vm.logoDimension = { width: 600, height: 600 };

			var viewConfirmation = new ConfirmationModalFactory({}, {
				message: 'messages.warning.viewChange.MESSAGE',
				code: 'messages.warning.viewChange.CODE',
			});
			var toInactiveConf = new ConfirmationModalFactory({}, {
				message: 'messages.warning.statusChange.MESSAGE.TO_COMPANY_INACTIVE',
				code: 'messages.warning.statusChange.CODE'
			});
			var toActiveConf = new ConfirmationModalFactory({}, {
				message: 'messages.warning.statusChange.MESSAGE.TO_COMPANY_ACTIVE',
				code: 'messages.warning.statusChange.CODE'
			});

			var messeagePlan = new ConfirmationModalFactory({}, {
				message: 'Plan reassignment for the selected Company is currently in progress and may take a few minutes to complete. Please check the Margins module after 3 to 5 minutes to confirm the update has been applied.',
				code: 'messages.warning.statusChange.CODE'
			});


			init();

			function init() {

				var promises = [initCompanyDetails(), searchForCountry()];
				$q.all(promises).then(function (data) {
					if (vm.company.resellerId) {
						getCompanyDetails(vm.company.resellerId).then(function (reseller) {
							vm.company.reseller = reseller;

						});
					}
				});

				setShowLiveRateSwitcher();
				setIsAdmin();
				switchOnAccount()
			}

			function setIsAdmin() {
				vm.isAdmin = $rootScope.GlobalProfile.id === 1;
			}

			function getCompanyDetails(id) {
				const defer = $q.defer();
				ClientService.Company.get(id, function (data) {
					defer.resolve(data)
				}, function (err) {
					defer.reject(err);
				});

				return defer.promise;
			}

			function switchOnAccount() {
				vm.company.billingProfile.onAccount = vm.onAccount
				if (!vm.onAccount) {
					vm.company.billingProfile.adHocPayment = true;
					vm.company.billingProfile.sweepPayment = true;
					return;
				}

				vm.company.billingProfile.adHocPayment = false;
				vm.company.billingProfile.sweepPayment = false;
			}

			function switchCreditCard(val, index) {
				if (!vm.onAccount) {
					if (index === 0 && !val) {
						vm.company.billingProfile.sweepPayment = true;
						return;
					}
					if (index === 1 && !val) {
						vm.company.billingProfile.adHocPayment = true;
						return;
					}
				}
			}

			function initCompanyDetails() {
				const defer = $q.defer();
				if (vm.companyId) {
					vm.isFetching = true;
					getCompanyDetails(vm.companyId).then(data => {
						defer.resolve(data);
						vm.isFetching = false;
						vm.company = data;
						vm.origOfficeEmail = data.email;
						vm.onAccount = data.billingProfile.onAccount;
						vm.creditPayment = data.billingProfile.creditEnabled;
						vm.warrantyEnabled = data.warrantyEnabled;

						if (data.location) {
							vm.company.suburb = data.location.name;
							vm.company.country = data.location.country;
							vm.company.state = data.location.state ? data.location.state.name : '';
							vm.company.postCode = data.location;
						}

						vm.companyRaw = angular.copy(vm.company);
						vm.companyOld = angular.copy(vm.company);
					}).catch(err => {
						defer.reject(err);
					});
				}
				else {
					$timeout(() => defer.reject());
					vm.companyRaw = angular.copy(vm.company);
				}
				return defer.promise;
			}

			function searchForCountry(model) {
				const defer = $q.defer();
				Location.Country({
					// name: model
				}, function (data) {
					defer.resolve(data);
					vm.countries = data;
					if (data.length <= 0)
						vm.countries = [{
							name: 'No Search Result'
						}];
				}, function (err) {
					defer.resolve(err);
					vm.countries = [{
						name: 'No Search Result'
					}];
				});
				return defer.promise;
			}

			function searchForCompanies(select) {
				vm.companies = [];
				if (!select.open) {
					return false;
				}
				vm.searchingForCompany = true;
				ClientService.Reseller.getAll(
					function (data) {
						vm.companies = data.content;
						vm.searchingForCompany = false;
					}, function (err) {
						vm.searchingForCompany = false;
					}, {
					size: 20, active: true, name: select.search
				});
			}

			function selectCountry(item, model) {
				if (item.code) {
					angular.extend(vm.company, {
						location: {
							country: item
						}
					});
					searchForZipcode(vm.company.location.country);
				}
			};

			function selectbillingProfileCountry(item, model) {
				if (item.code) {
					angular.extend(vm.company.billingProfile, {
						location: {
							country: item
						}
					});
					vm.postCodes = [];
				}
			};

			function searchForZipcode(country, model = '', size = 2000) {
				Location.ZipCode({
					country: country ? country.code : 'None',
					size: size,
					sort: 'code',
					code: model
				}, function (data) {
					vm.postCodes = buildStates(data.content);
					if (!data.content.length)
						vm.postCodes = [{
							code: 'No post code found'
						}];
				}, function (err) {
					vm.postCodes = [{
						code: 'No post code found'
					}];
				})
			};

			function selectPostCode(item) {
				if (item.code) {
					angular.extend(vm.company.location, item);
				}
			}

			function selectbillingProfilePostCode(item) {
				if (item.code) {
					angular.extend(vm.company.billingProfile.location, item);
				}
			}
			function buildStates(codes) {
				var distinctCodes = [];
				angular.forEach(codes, function (code, key) {
					if (codes[key - 1] && code.code == codes[key - 1].code) {
						distinctCodes[distinctCodes.length - 1].altStates.push(code);
					} else {
						code.altStates = [code];
						distinctCodes.push(code);
					}
				});
				return distinctCodes;
			}
			vm.cardTypes = [{
				name: "Master Card",
				value: "mc"
			}, {
				name: "Visa",
				value: "visa"
			},];

			function changeStatus(event) {
				if (!vm.company.active) {
					vm.company.active = true;
					event.preventDefault();
					toInactiveConf.getInstance().result.then(function (cond) {
						if (cond) {
							$timeout(function () {
								vm.company.active = false;
							});
						}
					});
				}
				else if (vm.company.active) {
					vm.company.active = false;
					event.preventDefault();
					toActiveConf.getInstance().result.then(function (cond) {
						if (cond) {
							$timeout(function () {
								vm.company.active = true;
							});
						}
					});
				}
			};

			function isSameValues(obj1, obj2) {
				if (obj1 === obj2) return true;

				if (
					typeof obj1 !== 'object' ||
					typeof obj2 !== 'object' ||
					obj1 === null ||
					obj2 === null
				) return false;

				const keys1 = Object.keys(obj1);
				const keys2 = Object.keys(obj2);

				if (keys1.length !== keys2.length) return false;

				for (let key of keys1) {
					if (!keys2.includes(key)) return false;
					if (!isSameValues(obj1[key], obj2[key])) return false;
				}

				return true;
			}

			function save(...forms) {
				let validData = forms.every(form => {
					form.$setSubmitted();
					if (form.$invalid) {
						scrollToForm(form.$name);
					}
					return form.$valid;
				});

				if (!validData) {
					return false;
				}
				var requestData = angular.copy(vm.company);
				requestData.active = !!requestData.active;

				const validate = isSameValues(vm.companyOld, requestData);
				if (!validate) {


					messeagePlan.getInstance().result.then(function (cond) {
						if (cond) {
							saveCompanyDetails(requestData)
						}

					})
					return;
				}
				saveCompanyDetails(requestData)

			}

			function saveCompanyDetails(requestData) {
				vm.isFetching = true;
				if (vm.company.location) {
					requestData.location = vm.company.location.id;
					delete requestData.postCode;
					delete requestData.country;
					delete requestData.suburb;
					delete requestData.state;
				}
				if (vm.company.billingProfile.location) {
					requestData.billingProfile.location = vm.company.billingProfile.location.id;
				}
				if (vm.company.reseller) {
					requestData.resellerId = vm.company.reseller.id;
					delete requestData.reseller;
				}

				if (vm.companyId) {
					updateHideInformation(angular.copy(requestData.hideReceiverInfo));
					enableWarrantyDetails(angular.copy(requestData.warrantyEnabled));
					ClientService.Company.update(requestData, function (response) {
						upload(vm.companyLogo, response.id).finally(data => {
							postUpdated(data);
						});
						function postUpdated(data) {
							vm.isFetching = false;
							vm.params.companyId = data != undefined ? data.id : response.id;
							vm.companyId = data != undefined ? data.id : response.id;
							vm.company = data || response;
							vm.companyRaw = data || response;
							vm.companyOld = angular.copy(vm.company);
							toastr.success("Company has been updated");
						}
					}, function (error) {
						toastr.error(error.message);
						vm.isFetching = false;
					}, vm.companyId);
				} else {
					ClientService.Company.create(requestData, function (response) {
						vm.company = response;
						vm.companyRaw = response;
						upload(vm.companyLogo, response.id).finally(() => {
							toastr.success("Company has been created");
							$location.path('/clients/company/details/' + response.id);
						});
					}, function (error) {
						toastr.error(error.message);
						vm.isFetching = false;
					});
				}
			}

			function updateHideInformation(isHidden) {
				ClientService.Company.hideDetails(vm.companyId, isHidden, (data) => {
					toastr.success(`Receiver detais are now ${isHidden ? 'hidden' : 'shown'}.`);
					vm.company.hideReceiverInfo = isHidden;
				}, error => {
					toastr.error(error.message, 'Error');
				});
			}

			function enableWarrantyDetails(isHidden) {
				ClientService.Company.enableWarrantyDetailsAdmin(vm.companyId, isHidden, (data) => {
					toastr.success(`Warranty detais are now ${isHidden ? 'shown' : 'hidden'}.`);
					vm.company.warrantyEnabled = isHidden;
				}, error => {
					toastr.error(error.message, 'Error');
				});
			}

			function updateHideInformationAdmin(isHidden) {
				ClientService.Company.hideDetailsAdmin(vm.companyId, isHidden, (data) => {
					toastr.success(`Receiver detais are now ${isHidden ? 'hidden' : 'shown'} in admin.`);
					vm.company.hideReceiverInfo = isHidden;
				}, error => {
					toastr.error(error.message, 'Error');
				});
			}

			function goTo(path, params) {
				$location.path(path).search(params);
			}

			function back() {
				$location.path('/clients');
			}

			let onRouteChangeOff = $rootScope.$on('$routeChangeStart', routeChange);
			function routeChange(event, next, current) {
				let path = next.$$route.originalPath;
				if (path !== '/clients/company/details/:companyId') {
					if (!vm.isViewMode && isChanged(vm.company, vm.companyRaw)) {
						event.preventDefault();
						viewConfirmation.getInstance().result.then(function (cond) {
							if (cond) {
								onRouteChangeOff();
								if (path === '/clients/:companyId/list') {
									const newPath = path.replace(':companyId', vm.params.companyId);
									$location.path(newPath);
									return;
								}
								$location.path(path);
							}
						});
					}
				}
			}

			function isChanged(newValue, oldValue) {
				return !angular.equals(ClientService.Company.cleanPayload(newValue), ClientService.Company.cleanPayload(oldValue));
			}
			function isUnique(model, formField, origVal, prop) {
				let params = {};
				params.model = model;
				params.origName = origVal;
				params.formField = formField;
				params.service = ClientService.Company;
				params.serviceMethod = "getAll";
				params.property = prop;
				params.warningMsg = `${prop} is already taken`;
				isUniqueService.isUnique(params);
			}

			function validateEmail(model) {
				vm.invalidEmail = null;
				if (model === vm.companyRaw.email || !model) {
					return false;
				}
				vm.validating = true;
				ClientService.Company.validateEmail({
					resellerId: angular.getObjVal(vm, 'company.reseller.id') || '0',
					email: model
				}, data => {
					vm.validating = false;
					vm.invalidEmail = data ? null : 'This email is already taken';
				}, err => {
					vm.validating = false;
					toastr.error('Unable to validate email', err.message);
					vm.invalidEmail = 'This email is already taken';
				})
			}

			function upload(file, companyId) {
				const defer = $q.defer();
				if (!file) {
					$timeout(() => defer.reject({}));
				} else {
					Upload.resize(file, vm.logoDimension).then(resizedFile => {
						ClientService.Company.uploadLogo(resizedFile, companyId, data => {
							defer.resolve(data);
						}, err => {
							defer.reject(err);
							toastr.error('Unable to save logo', 'Please try again later');
						})
					});

				}
				return defer.promise;
			}

			function setShowLiveRateSwitcher() {
				const isReseller = $rootScope.GlobalProfile.company.isReseller;
				vm.isShowLiveRateSwitcher = isReseller || vm.isAdmin;
			}
		});
})();



// WEBPACK FOOTER //
// ./js/controllers/client/ClientCompanyController.js